import { favoriteAdsResponseSchema } from '../../models/favorites/morph.js';
import { favoriteAdsResponse } from '../../models/favorites/zod.js';
import { clientGet, clientDelete, clientPost } from '../../utils/fetchwrapper.js';
import { processBody, returnStatus } from '../../utils/fetchwrapperUtils/responseProcessors.js';

const getFavorites = (origin, userId, sbtHeaders) => clientGet({
    url: `${origin}/v1/favorites/search/users/${userId}/items`,
    sbtHeaders,
}).then(processBody(favoriteAdsResponseSchema, favoriteAdsResponse));
const unsaveFavorite = (origin, urn, userId) => clientDelete({
    url: `${origin}/v1/favorites/search/users/${userId}/items?urns=${urn}`,
}).then(returnStatus);
const saveFavorite = (origin, urn, userId, sbtHeaders) => clientPost({
    url: `${origin}/v1/favorites/search/users/${userId}/items`,
    sbtHeaders,
}, {
    urn,
}).then(returnStatus);

export { getFavorites, saveFavorite, unsaveFavorite };
//# sourceMappingURL=client.js.map
